<template>
    <card card-body-classes="" no-footer-line>
        <div class="row justify-content-center programme">
            <!-- details -->
            <div class="col-sm-8">
                <h4 class="card-title text-left" >{{ title }} - <small>{{ department }}</small></h4>
                <p class="card-text">{{ description }}</p>
                <template v-if="typeof(paper) == 'string'">
                    <p class="card-text" v-if="login && paper">More details can be found here: <router-link tag="a" :to="`/CBCS/papers/preview/${paper}`">Click Here</router-link></p>
                    <p class="card-text" v-if="!login && paper">More details can be found here: <router-link tag="a" :to="`/papers-${paper}`">Click Here</router-link></p>
                </template>
                <template v-else>
                    <p class="card-text" v-if="login && paper && paper[0]">More details can be found here: <router-link tag="a" :to="`/CBCS/papers/preview/${paper[0].slug}`">Click Here</router-link></p>
                    <p class="card-text" v-if="!login && paper && paper[0]">More details can be found here: <router-link tag="a" :to="`/papers-${paper[0].slug}`">Click Here</router-link></p>
                </template>
                <div class="row">
                    <div class="col-sm-4" v-if="(login && isAdmin)">
                        <span class="card-text bb-lines">
                            <n-progress v-if="seating" :type="progressClass" :label="`Registration Status [ ${seating.current_seat} / ${seating.max_seat} ]`" :value="Math.round((seating.current_seat/seating.max_seat)*100)" show-value></n-progress>
                            <p class="bb-line" v-if="seating"> <small>Registrations:</small> <span class="pull-right">{{ seating.current_seat }}</span> </p>
                            <p class="bb-line" v-if="seating"> <small>Remaining Registrations:</small> <span class="pull-right">{{ seating.max_seat - seating.current_seat }}</span> </p>
                            <p class="bb-line" v-if="seating"> <small>Max Registrations:</small> <span class="pull-right">{{ seating.max_seat }}</span> </p>
                            <p class="bb-line" v-if="permitted_enrollments"> <small>Permitted Enrollments:</small> <span class="pull-right">{{ permitted_enrollments }}</span> </p>
                            <p class="bb-line" v-if="max_teams"> <small>Max Teams:</small> <span class="pull-right">{{ max_teams }}</span> </p>
                            <template v-if="(pool && type =='group') || entity == 'event'">
                                <p class="bb-line" v-if="min_participants"> <small>Min Participants:</small> <span class="pull-right">{{ min_participants }}</span> </p>
                                <p class="bb-line" v-if="max_participants"> <small>Max Participants:</small> <span class="pull-right">{{ max_participants }}</span> </p>
                            </template>

                        </span>
                    </div>
                    <div class="col-sm-8 mr-auto">
                        <p class="card-text" v-if="open_date && close_date">
                            <small>Registration Window:</small><br>{{ formattedDate(open_date) }} - {{ formattedDate(close_date) }}
                        </p>
                        <p class="card-text" v-if="start_date && end_date">
                            <small>Date & Time: </small><br>{{ formattedDate(start_date) }} - {{ formattedDate(end_date) }}
                        </p>
                        <p class="card-text" v-if="venue">
                            <small>Venue: </small><br>{{ venue }}
                        </p>
                    </div>
                </div>
            </div>
            <!-- end details -->
            <!-- image -->
            <div class="col-sm-4">
                <div class="cover-img" v-if="image" :style="`background-image:url(${image})`"></div>
            </div>
            <!-- end image -->
            <!-- coordinators -->
            <div class="col-12" v-if="coordinators && coordinators.length > 0">
                <div class="card-title">Coordinators</div>
                <div class="row justify-content-center">
                    <div class="col-md-5" v-for="(coordinator, index) in coordinators" :key="index">
                        <div class="card coordinator-card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-3 text-center">
                                        <div class="avatar">
                                            <img :src="getAvatar(coordinator)" alt="">
                                        </div>
                                    </div>
                                    <div class="col-9">
                                        <h6 class="mt-2">{{ coordinator.designation }} {{ coordinator.name }} <br> <small>{{ coordinator.title }}</small></h6>
                                        <a :href="`tel:${coordinator.phone}`">{{ coordinator.phone }}</a> <br/>
                                        <a :href="`mailto:${coordinator.email}`">{{ coordinator.email }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end coordinators -->
            <!-- form -->
            <div class="col-12 mt-4" v-if="!isAdmin && ((form && form.length > 0) || (pool && (batches.length < 1 && login)))">
                <DynamicForm
                    :login="login"
                    :pool="pool"
                    :visible="visible"
                    :batches="batches"
                    :withSubmit="isBtnActive" 
                    :showSubmit="showSubmit"
                    :price="price" 
                    :form="form"  
                    :action="null" 
                    :slug="slug" 
                    :title="title" 
                    :max_teams="max_teams" 
                    :min_participants="min_participants" 
                    :max_participants="max_participants"
                    :participants_pool="filteredParticipantsPool"
                    :multipleEntry="multipleEntry" 
                    :events="events"
                    @on-pool="gotParticipants"
                    @on-submit="gotForm"
                    :programme="programme"
                    :entity="entity"
                    :isOpen="isOpen"
                    :open_date="open_date"
                    @on-form-update="onformUpdateProgramme">
                        <template slot="header" class="text-center">
                            <p class="card-text text-center" >Registration form for {{ title }}</p>
                        </template>
                        <template slot="events">
                            <!-- events form -->
                            <div class="card-body" v-if="events.length > 0 && entity == 'programme'">
                                <p class="card-text">Events</p>
                                <hr>
                                <tabs type="primary">
                                    <tab-pane :label="event.title" v-for="(event, index) in events" :key="index">
                                        <RegisterForm 
                                            v-bind="event" 
                                            entity="event" 
                                            :programme-events="programmeEvents"
                                            :participants_pool="filteredParticipantsPool" 
                                            :withSubmit="false" 
                                            :showSubmit="false" 
                                            @on-form-update="onformUpdateEvent">
                                        </RegisterForm>
                                    </tab-pane>
                                </tabs>
                            </div>
                        </template>
                </DynamicForm>
            </div>
            <!-- end form -->
        </div>
    </card>
</template>

<script>
import { DynamicForm, Tabs, TabPane, Collapse, CollapseItem, Progress as NProgress, RegistrationProgress as RProgress } from "src/components";
import { Tooltip } from 'element-ui'
import { FgEventRenderer } from 'fullcalendar';
import { mapGetters } from 'vuex';
export default {
    name: 'RegisterForm',
    components: {
        DynamicForm,
        Tabs,
        TabPane,
        Collapse,
        CollapseItem,
        [Tooltip.name]: Tooltip,
        RProgress,
        NProgress,
    },
    props: {
        entity: String,
        slug: String,
        venue: String,
        type: String,
        login: Boolean,
        visible: Boolean,
        pool: Boolean,
        multipleEntry: {
            type: Boolean,
            default: true
        },
        title: String,
        description: String,
        price: [Number, String],
        department: String,
        image: String,
        batches: {
            type: [Array, String],
            default: () => []
        },
        form: Array,
        coordinators: Array,
        seating: {
            type: Object,
            default: function(){
                    return {max_seat: 0}
                }
        },
        permitted_enrollments: Number,
        open_date: [Date, String],
        close_date: [Date, String],
        start_date: [Date, String],
        end_date: [Date, String],
        max_teams: Number,
        min_participants: Number,
        max_participants: Number,
        participants_pool: Array,
        withSubmit: {
            type: Boolean,
            default: false
        },
        showSubmit: {
            type: Boolean,
            default: true
        },
        events: {
            type: Array,
            default: () => []
        },
        programmeEvents: {
            type: Array,
            default: () => []
        },
        programme: Object,
        paper: {
            type: [Array, String],
            default: () => []
        },
        isOpen: {
            type: Boolean,
            default: false
        },
    },
    data(){
        return {
            validity: {
                programme: false,
                event: false
            },
            submission_form: null
        }
    },
    methods: {
        formattedDate(cellValue, withTime = true){
            if(!cellValue)
                return '--';
            var d = new Date(cellValue);
            var options = (withTime) ? { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' } : { year: 'numeric', month: 'long', day: 'numeric' }
            return  d.toLocaleDateString('en-US', options); 
        },
        onformUpdateProgramme({validity, form}){
            // if(form.entity == 'programme'){
                if(validity){
                    console.log("onformUpdateProgramme ~ form", form)
                }

                this.submission_form = form
                    
            // }
            this.validity.programme = validity
            this.$emit('on-form-update', {validity, form})
        },
        onformUpdateEvent({validity, form}){
            // if(form.entity == 'event'){
                if(validity)
                    console.log("onformUpdateEvent ~ form", form)

                // is events available in submission_form
                if (!('events' in this.submission_form)){
                    this.submission_form.events = []
                }
                // find the event from the exisiting list of events
                let event = this.submission_form.events.find(ev => form.slug == ev.slug)
                console.log("🚀 ~ file: RegisterForm.vue ~ line 228 ~ onformUpdateEvent ~ event", event)
                
                if(event){
                    // if found replace the event with updated form
                    event = form
                }
                else{
                    // else append/push the form to the list of events
                    this.submission_form.events.push(form)
                    console.log('added', this.submission_form);
                }

            // }
            this.validity.event = validity
            this.$emit('on-form-update', {validity, form})

        },
        gotParticipants(pool){
            this.$emit('on-pool', Object.assign([], pool))
        },
        gotForm(form){
            console.log("TCL: gotForm -> form", form)
            console.log("submit form", this.submission_form);
            // got form for submission
            // this.$store.dispatch('createRegistration', form)

            var myform = document.createElement("form");
                    
            var payload = document.createElement("input");
            payload.value = JSON.stringify(this.submission_form);
            payload.name = "payload";
            myform.appendChild(payload);

            var headers = document.createElement("input");
            headers.value = JSON.stringify(this.tokens);
            headers.name = "headers";
            myform.appendChild(headers);

            myform.action = `${process.env.VUE_APP_BASE_URL}/tukio/users/register`;
            myform.method = "post";
            document.body.appendChild(myform);
            myform.submit();
            console.log('submit');
        },
        getAvatar(coordinator){
            return (coordinator.image) ? coordinator.image : `https://ui-avatars.com/api/?background=0D8ABC&color=FFF&bold=true&size=128&name=${coordinator.name}`
        }
    },
    computed: {
        ...mapGetters({
            headers: "getHeaders",
            tokens: "getAuthTokens" 
        }),
        progressClass: function () { 
            let percent = Math.round((this.seating.current_seat/this.seating.max_seat)*100)
            if(percent <= 75){
                return 'success'
            }
            else if(percent <= 99){
                return 'warning'
            }
            else{
                return 'danger'
            }
        },
        isBtnActive(){
            if(this.events.length > 0 && this.entity == 'programme'){
                // programme with events
                return this.validity.programme && this.validity.event && this.withSubmit
            }
            else{
                // only programme no events
                return this.validity.programme && this.withSubmit
            }
        },
        isAdmin(){
            return (this.$currentUser) ? this.$currentUser.roles.includes('admin') : false
        },
        filteredParticipantsPool(){
            if(this.entity == 'event' && this.multipleEntry == false){
                let selected = this.programmeEvents.map(e => e.slug != this.slug && e.form.filter(i=> ['participant', 'student', 'teacher'].includes(i.fieldtype) && i.value).map(i => i.value));
                selected = selected.reduce((a, b) => a.concat(b), []);
                return this.participants_pool ? this.participants_pool.filter(part => !selected.includes(part.email)) : []
            }
            else
                return this.participants_pool
        }
    }
}
</script>

<style lang="scss">

.progress-container {
    margin-bottom: 1rem;
    .progress-badge{
        text-transform: initial;
    }
}

.programme{
    .cover-img{
        height: 200px;
    }
    .card-title{
        margin-top: 0;
    }
}

.event{
    .cover-img{
        height: 100px;
    }
    .card-title{
        margin-top: 0;
    }
}

.cover-img{
    width: 100%;
    height: 150px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
}

.card-text .btn{
    margin-top: 0;
    margin-bottom: 0;
}

p.card-text{
    margin-bottom: 0.5rem !important;
}

.side-text{
    margin-left: 5px;
}

p.bb-line{
    margin: 0;
    border-bottom: solid 1px #eee;
}

p.bb-line:last-child{
    border-bottom: solid 1px #fff;
}

.coordinator-card {

    .card-body{
        padding: 5px;
    }
    .avatar{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        img{
            width: 75px;
            height: 75px;
            overflow:hidden;
            border-radius: 100%;
            margin: 0 auto;
        }
    }
}
</style>
